// Registers `form.draft.set` with the global CardRegistry, read-only: saving
// happens only through cowork/OwnerFormSetDraft in the drawer's draft branch.
// The view is a separate chunk, loaded the first time a set card renders.
import { Suspense, createElement } from "react";

import { registerCardComponent } from "@/components/generative-ui/envelope";
import type { FormDraftSetCardEnvelope } from "@/components/generative-ui/envelope/types";
import { lazyWithRetry } from "@/routes/lazy-with-retry";

const FormDraftSetCardView = lazyWithRetry(() => import("./FormDraftSetCard"), "FormDraftSetCardView");

function FormDraftSetCardEntry({ card }: { card: FormDraftSetCardEnvelope }) {
  return createElement(Suspense, { fallback: null }, createElement(FormDraftSetCardView, { card }));
}

registerCardComponent("form.draft.set", FormDraftSetCardEntry);
